import classic from "@assets/token-frame-grey.webp";
import ornate from "@assets/token-frame-gunmetal.webp";
import ouroboros from "@assets/token-frame-ouroboros.webp";
import orange from "@assets/token-frame-orange.webp";
import purple from "@assets/token-frame-purple.webp";
import celtic from "@assets/token-frame-celtic.webp";
import ravenFeathers from "@assets/token-frame-raven-feathers.webp";
import ravenloft from "@assets/token-frame-ravenloft.webp";
import thornWreath from "@assets/token-frame-thorn-wreath.webp";
import gravestone from "@assets/token-frame-gravestone.webp";
import {DEFAULT_TOKEN_FRAME_STYLE, type TokenFrameStyle} from "@/encounter/model/TokenFrameStyle.ts";

// Both 800 x 800 frames cover the portrait from a source radius of about 340 px.
// Let the portrait extend a few pixels beneath the artwork to avoid a visible seam.
export const TOKEN_PORTRAIT_RADIUS_RATIO = 345 / 400;

export const TOKEN_FRAME_STYLES = [
    {id: "CLASSIC", label: "Klassisch", image: classic},
    {id: "ORNATE", label: "Verziert", image: ornate},
    {id: "OUROBOROS", label: "Ouroboros", image: ouroboros},
    {id: "ORANGE", label: "Orange", image: orange},
    {id: "PURPLE", label: "Purple", image: purple},
    {id: "CELTIC", label: "Keltisch", image: celtic},
    {id: "RAVEN_FEATHERS", label: "Rabenfedern", image: ravenFeathers},
    {id: "RAVENLOFT", label: "Ravenloft", image: ravenloft},
    {id: "THORN_WREATH", label: "Dornenkranz", image: thornWreath},
    {id: "GRAVESTONE", label: "Grabstein", image: gravestone},
] as const satisfies ReadonlyArray<{
    id: TokenFrameStyle;
    label: string;
    image: string;
}>;

export function tokenFrameStyle(value: TokenFrameStyle | undefined): TokenFrameStyle {
    return TOKEN_FRAME_STYLES.some(style => style.id === value) ? value! : DEFAULT_TOKEN_FRAME_STYLE;
}

export function tokenFrameImage(style: TokenFrameStyle): string {
    const entry = TOKEN_FRAME_STYLES.find(candidate => candidate.id === style) ?? TOKEN_FRAME_STYLES[0];
    return entry.image;
}
